import { Injectable, EventEmitter } from '@angular/core';
function unimplemented(...args: any[]) {
    console.error(new Error("This function is not implemented"));
}
let ipcRenderer = {
    on: unimplemented,
    send: unimplemented,
};

eval(`try {ipcRenderer = require("electron").ipcRenderer;} catch(err) {console.warn(err);}`);

export interface IIpcEventEmitter {
    args: any[];
}

@Injectable()
export class IpcService {
    public ipc = ipcRenderer;

    observe(name: string): EventEmitter<IIpcEventEmitter> {
        const eventEmitter: EventEmitter<IIpcEventEmitter> = new EventEmitter();
        this.ipc.on(name, (...args) => {
            eventEmitter.emit({ args });
        });
        return eventEmitter;
    };

    send(name: string, ...args: any[]) {
        this.ipc.send.apply(this.ipc, [name, ...args]);
    }
}


// WEBPACK FOOTER //
// ./src/providers/ipc/ipc.ts